import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "../api/auth";

const SignOut = () => {
    const navigate = useNavigate();

    useEffect(() => {
        signOut().then((data) => {
            //console.log(data);
            //alert(1);
            if (data.status === "success") {
                //localStorage.removeItem("ncpc_user_not_so_top_secret_data");
                //localStorage.removeItem("ncpc_user_top_secret_data");
                //console.log("Signout Successful.");
                navigate("/"); // Redirect to home page
                // Should be done with a global state in the future
                //window.location.reload(); // Refresh the Header.jsx //It refreshes itself automatically as this is not a function which it probably should be.
            }
        }).catch((error) => {
            console.error("Signout failed:", error);
        });
    }, [navigate]);

    return (
        <div>
            Signing out...
        </div>
    );
};

export default SignOut;